import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

// Components
import GenerateCertificate from 'app/views/components/GenerateCertificate'
import ModalSetUsername from 'app/views/components/Modals/ModalSetUsername'

// Redux
import { updateSendReminders, getHackerDetails } from 'app/state/modules/hacker'

// Utils
import analytics from 'app/views/utils/analytics'

const propTypes = {
  license: PropTypes.bool,
}
const defaultProps = {
  license: false,
}

class Profile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sendReminders: false,
    }

    this.handleSendRemindersChange = this.handleSendRemindersChange.bind(this)
  }

  componentDidMount() {
    analytics.page('page-profile')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.profile.send_reminders !== this.state.sendReminders) {
      this.setState({ sendReminders: nextProps.profile.send_reminders })
    }
  }

  getLastCompletedDate(courses) {
    let lastCompletedDate = null
    courses.forEach((course) => {
      if (course.completed_at) {
        if (lastCompletedDate) {
          if (moment(course.completed_at).isAfter(lastCompletedDate)) {
            lastCompletedDate = course.completed_at
          }
        } else {
          lastCompletedDate = course.completed_at
        }
      }
    })
    return lastCompletedDate
  }

  handleSendRemindersChange() {
    this.props.updateSendReminders(!this.props.profile.send_reminders)
  }

  render() {
    return (
      <div data-test-id="profile-component" className="uk-background-muted" style={{ minHeight: 'calc(100vh - 80px)' }}>
        <div className="uk-section">
          <div className="uk-container">
            <div className="uk-child-width-expand@s" data-uk-grid>
              <div className="uk-width-1-3@m">
                <div data-test-id="username-manage-container" className="uk-card uk-card-default uk-card-body">
                  <div className="uk-text-center">
                    <span data-uk-icon="icon: user; ratio: 3.5" />
                  </div>
                  <h4>{this.props.profile.email}</h4>
                  {this.props.profile.username ? (
                    <div>
                      <p>
                        {this.props.profile.username}
                        &nbsp;
                        (
                          <Link data-test-id="change-username-btn" to="#" data-uk-toggle="#modal-set-username">
                            Change Username
                          </Link>
                        )
                      </p>
                    </div>
                  ) : (
                    <button
                      data-test-id="set-username-btn"
                      type="button"
                      className="uk-button uk-button-primary uk-button-small tm-button-primary"
                      data-uk-toggle="#modal-set-username"
                    >
                      Set a Username
                    </button>
                  )}
                </div>

                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>Communication Preferences</h4>
                  <div>
                    <input
                      data-test-id="reminders-checkbox"
                      className="uk-checkbox"
                      type="checkbox"
                      onChange={this.handleSendRemindersChange}
                      style={{ marginRight: 10 }}
                      checked={this.state.sendReminders}
                    />
                    <label htmlFor="proxy-intercept" className="uk-text-small uk-text-bold">
                      Receive Reminder Emails
                    </label>
                  </div>
                </div>
              </div>

              <div className="uk-width-2-3@m">
                <div className="uk-card uk-card-default uk-card-body">
                  {this.props.license === true ? (
                    <div>
                      <h4>Subscription</h4>
                      <p>
                        If you would like to cancel your subscription, email us at <a href="mailto:support@hackedu.io">support@hackedu.io</a>
                      </p>
                    </div>
                  ) : (
                    <div>
                      <h4>Subscription</h4>
                      <p>You do not have a HackEDU Subscription</p>
                      <Link to="/upgrade" className="uk-button uk-button-primary tm-button-primary">
                        Upgrade Now
                      </Link>
                    </div>
                  )}
                </div>

                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>Training</h4>
                  <div>
                    {this.props.profile.has_finished_training
                    && typeof this.props.profile.email === 'string' ? (
                      <GenerateCertificate
                        email={this.props.profile.email}
                        completionDate={this.props.profile.last_completed_at}
                        courseName={this.props.user.plan_title}
                        className="uk-button uk-button-default"
                      >
                        <span uk-icon="download" />
                        &nbsp; Generate Certificate
                      </GenerateCertificate>
                      ) : (
                      <p>You have not completed the OWASP Top 10 training plan</p>
                      )}
                  </div>
                </div>

                <div className="uk-card uk-card-default uk-card-body uk-margin">
                  <h4>Quiz</h4>
                  <div>
                    <Link to="/quiz">Take Assessment</Link>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <ModalSetUsername />
      </div>
    )
  }
}

Profile.propTypes = propTypes
Profile.defaultProps = defaultProps

const mapStateToProps = state => ({
  // hacker
  license: state.hacker.license,
  profile: state.hacker.profile,
  user: state.hacker.currentHackerDetails,
})
const mapDispatchToProps = dispatch => ({
  updateSendReminders: sendReminders => dispatch(updateSendReminders(sendReminders)),
  dispatchGetHackerDetails: (teamId, hackerId) => dispatch(getHackerDetails(teamId, hackerId)),
})
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile)
